import { css } from "@emotion/css";

export const createLevelsPageStyles = () => {
  return {
    notFound: css({
      display: "flex",
      flexDirection: "column",
      marginTop: "4%",
    }),
  };
};
